import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dialog-default',
  templateUrl: './dialog-default.component.html',
  styleUrl: './dialog-default.component.scss'
})
export class DialogDefaultComponent {
  @Input() title = '';
  @Output() confirm = new EventEmitter<void>();

  onConfirm() {
    this.confirm.emit();    
  }

}
